//import 'dotenv/config'

export const BACKEND_URL = "https://action-link-stage.townesquare.xyz/";
export const PINATA_JWT = process.env.REACT_APP_PINATA_JWT;
export const PINATA_GATEWAY = process.env.REACT_APP_PINATA_GATEWAY;
export const FILEBASE_ACCESS_KEY = process.env.REACT_APP_FILEBASE_KEY;
export const FILEBASE_SECRET_KEY = process.env.REACT_APP_FILEBASE_SECRET_KEY;